import * as React from 'react'
import { NavMain } from '@/components/nav-main'
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarRail
} from '@/components/ui/sidebar'
import getSidebarData from '@/components/data/sidebar-data'
import { APP_NAME } from '@/utils/constant.tsx'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const data = getSidebarData()
    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarHeader>
                <h1 className='text-xl text-gradient'>{APP_NAME}</h1>
            </SidebarHeader>
            <SidebarContent>
                <NavMain items={data.navSuperAdmin} />
            </SidebarContent>
            <SidebarFooter>
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}
